<script setup lang="js">
import { useRtl } from '~/hooks'

const popover = ref(null)
const attrs = useAttrs()
const { isRtl } = useRtl()

const style = computed(() => {
  return {
    '--n-rail-color': 'var(--lineBorder)',
    '--n-rail-color-hover': 'var(--lineBorder)',
    '--n-rail-height': '2px',
    '--n-fill-color': 'var(--specialBtnPrimary)',
    '--n-fill-color-hover': 'var(--specialBtnPrimary)',
    '--n-handle-size': '0px',
    '--n-dot-border-active': '1px solid var(--specialBtnPrimary)',
    '--n-dot-height': '6px',
    '--n-dot-width': '6px',
    '--n-dot-border-radius': '999px',
    '--n-dot-border': '1px solid var(--lineBorder)',
  }
})

watch(() => attrs.value, () => {
  popover.value?.syncPosition()
})
</script>

<template>
  <n-slider :reverse="isRtl" :style="style" :tooltip="false" class="tt-slider h-9 pt-2 text-textTertiary font-medium text-xs !mx-[10px] !my-0 !w-auto">
    <template #thumb>
      <n-popover ref="popover" raw trigger="hover" arrow-style="--n-color: var(--fillPagePrimary)" :text="`${$attrs.value}%`">
        <div class="flex flex-col px-3 py-2 space-y-3 text-xs bg-fillPagePrimary rounded text-textPrimary">
          {{ $attrs.value }}%
        </div>
        <template #trigger>
          <div class="w-3 h-3 border-[2px] border-btnPrimary rounded-full bg-fillPagePrimary hover:w-4 hover:h-4 transition-all duration-200" />
        </template>
      </n-popover>
    </template>
  </n-slider>
</template>

<style lang="scss" scoped>
.tt-slider {
  * {
    @apply transition-none;
  }
  :deep(.n-slider-rail) {
    .n-slider-dots .n-slider-dot {
      @apply rtl:translate-x-1/2 rtl:-translate-y-1/2 #{!important};
    }
    .n-slider-marks {
      --n-handle-size:4px;
      @apply top-3 #{!important};
      .n-slider-mark {
        @apply rtl:translate-x-1/2;
      }
    }
  }
}
</style>
